var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portrait_black_24dp 1",
    clipPath: "url(#clip0_10959_3576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 9.1875C9.93 9.1875 10.6875 8.43 10.6875 7.5C10.6875 6.57 9.93 5.8125 9 5.8125C8.07 5.8125 7.3125 6.57 7.3125 7.5C7.3125 8.43 8.07 9.1875 9 9.1875ZM12.375 12.1875C12.375 11.0625 10.125 10.5 9 10.5C7.875 10.5 5.625 11.0625 5.625 12.1875V12.75H12.375V12.1875ZM14.25 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.075 2.25 14.25 2.25ZM14.25 14.25H3.75V3.75H14.25V14.25Z",
    fill: "#BDA09F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10959_3576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBook);
export default __webpack_public_path__ + "static/media/user-book.eb0f345ab24c36ab4c840ab208d21fbe.svg";
export { ForwardRef as ReactComponent };